<template>
  <div v-if="response!=null" class="gwrapper">
    <div :class="[response.large ? 'largeTitle' : 'title']">{{title}}</div>
    <div>
      <highcharts :options="chartOptions" ref="chartComponent"></highcharts>
      <TrendGoalComponent v-if="trendGoalValue!==null" :value="trendGoalValue"/>
    </div>
  </div>

</template>

<script>

import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import solidGauge from "highcharts/modules/solid-gauge";
import TrendGoalComponent from "./TrendGoalComponent";
import {mapState} from "vuex";

highchartsMore(Highcharts);
solidGauge(Highcharts);

export default {
  name: 'ActivityGaugeWidget',

  components: {
    highcharts: Chart, TrendGoalComponent
  },

  computed: {
    ...mapState(['chartRedrawCounter']),
  },

  props: {
    widgetData: Object
  },

  data() {
    return {
      trendGoalValue: null,
      response: null,

      title: '',
      value: 0,


      chartOptions: {
        tooltip: { enabled: false },
        legend: { enabled: false },

        chart: {
          type: 'solidgauge',
          height: '110%',
        },

        title: {
          text: '92.0',
          align: 'center',
          verticalAlign: 'middle',
        },

        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
            outerRadius: '112%',
            innerRadius: '88%',
            backgroundColor: "#e5e5e5", //Highcharts.Color("#ff0000").setOpacity(0.3).get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        credits: {
          enabled: false
        },

        // exporting: {
        //   enabled: false
        // },

        series: [{
          name: 'Move',
          data: [{
            color: "#757575", //Highcharts.getOptions().colors[1],
            radius: '112%',
            innerRadius: '88%',
            y: 80
          }]
        }]

      }

     }
  },


  methods: {
    requestData(requester) {
      requester.addExpressionRequest(this.dataCallback, this.widgetData.extname, this.widgetData.expr);
    },

    dataCallback(dto) {
      this.response = dto;
      this.title = dto.title;
      this.trendGoalValue = dto.trendGoalValue
      this.chartOptions.title.text = dto.svalue
      this.chartOptions.series[0].data[0].y = dto.value
      this.chartOptions.yAxis.min = this.widgetData.min
      this.chartOptions.yAxis.max = this.widgetData.max
    },

  },

  watch: {
    chartRedrawCounter: function () {
      if(this.$refs.chartComponent && this.$refs.chartComponent.chart) {
        this.$refs.chartComponent.chart.reflow()
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .gwrapper {
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }

  div.title {
    padding-top: 1em;
    text-align: center;
  }

  div.largeTitle {
    text-align: center;
    font-size: 200%;
    margin-top: 20px;
  }

</style>
